(() => {
  const root = document.querySelector('[data-kk-cart-recommendations]');
  const track = root?.querySelector('[data-kk-cart-recommendations-track]');
  if (!root || !track) return;

  const cards = [...track.querySelectorAll('[data-kk-cart-recommendation]')];
  for (let i = cards.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [cards[i], cards[j]] = [cards[j], cards[i]];
  }
  cards.forEach((card) => track.appendChild(card));
  if (!cards.length) root.hidden = true;
})();
